export default __webpack_public_path__ + "static/media/check.88934aa2.svg";